document.addEventListener('DOMContentLoaded', () => {
  const nav = document.querySelector('.violex-nav');

  // ── Scroll: blendet die Leiste beim Runterscrollen aus ──────────────────────
  if (nav) {
    let lastScrollY = window.scrollY;

    const updateNavState = () => {
      const scrollY  = window.scrollY;
      const scrolled = scrollY > 40;
      nav.classList.toggle('is-scrolled', scrolled);

      const scrollingDown = scrollY > lastScrollY;
      if (scrollY > 80 && scrollingDown) {
        nav.classList.add('is-hidden');
      } else {
        nav.classList.remove('is-hidden');
      }
      lastScrollY = scrollY;
    };
    updateNavState();
    window.addEventListener('scroll', updateNavState, { passive: true });

    const setNavHeightVar = () => {
      document.documentElement.style.setProperty('--violex-nav-height', `${nav.offsetHeight}px`);
    };
    setNavHeightVar();
    window.addEventListener('resize', setNavHeightVar);
  }

  // ── Menu-Panel (alle Seiten) ──────────────────────────────────────────────
  // Gleiches Grundmuster wie das Warenkorb-Panel (violex-cart-drawer.js):
  // [hidden] weg beim Oeffnen, "is-open" fuer die Slide-in-Transition, per
  // Backdrop-Klick/Escape/×-Button wieder zu.
  const menu = document.getElementById('vx-nav-menu');
  const menuTrigger = document.querySelector('[data-vx-menu-trigger]');
  if (menu && menuTrigger) {
    const menuBackdrop = document.getElementById('vx-nav-menu-backdrop');
    const menuClose = document.getElementById('vx-nav-menu-close');

    const openMenu = () => {
      menu.hidden = false;
      requestAnimationFrame(() => menu.classList.add('is-open'));
      menuTrigger.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
    };
    const closeMenu = () => {
      menu.classList.remove('is-open');
      menuTrigger.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
      window.setTimeout(() => { menu.hidden = true; }, 320);
    };

    menuTrigger.addEventListener('click', () => {
      if (menu.hidden) openMenu(); else closeMenu();
    });
    menuBackdrop?.addEventListener('click', closeMenu);
    menuClose?.addEventListener('click', closeMenu);
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && !menu.hidden) closeMenu();
    });
  }

  // ── Ausklappbares Suchfeld ────────────────────────────────────────────────
  const searchPanel = document.getElementById('vx-nav-search');
  const searchTrigger = document.querySelector('[data-vx-search-trigger]');
  if (searchPanel && searchTrigger) {
    searchTrigger.addEventListener('click', () => {
      const willOpen = searchPanel.hidden;
      searchPanel.hidden = !willOpen;
      searchTrigger.setAttribute('aria-expanded', String(willOpen));
      if (willOpen) {
        searchPanel.querySelector('input[type="search"]')?.focus();
      }
    });
  }

  // ── Startseite: automatische Bilder-Slideshow ─────────────────────────────
  // 01.09.2026 (Wunsch Tomas). Die Bilder liegen im Markup schon alle
  // uebereinander (sections/violex-home.liquid), sichtbar ist immer genau
  // das mit der Klasse "is-active" - hier wird die Klasse reihum
  // weitergereicht, das Ueberblenden macht die CSS.
  //
  // Bewusst nichts tun bei genau einem Bild (nichts zum Wechseln) oder wenn
  // der Nutzer im System "Bewegung reduzieren" eingestellt hat: der Hero
  // fuellt den ganzen Bildschirm, ein automatischer Wechsel darin ist
  // genau die Art Bewegung, die diese Einstellung vermeiden will.
  const homeSlideshow = document.querySelector('[data-violex-home-slideshow]');
  if (homeSlideshow) {
    const slides = Array.from(homeSlideshow.querySelectorAll('.violex-home__slide'));
    const interval = Number(homeSlideshow.dataset.slideInterval) || 5000;
    // Erster Wechsel frueher (25.09.2026): so merkt man gleich nach dem
    // Oeffnen, dass es eine Slideshow ist - danach im normalen Takt.
    const firstDelay = Number(homeSlideshow.dataset.slideFirstDelay) || interval;
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (slides.length > 1 && !reduceMotion) {
      // Die Bilder ab dem zweiten sind loading="lazy" (spart Daten, wenn
      // jemand gleich weiterklickt). Da sie unsichtbar uebereinander liegen,
      // laedt der Browser sie aber nicht von selbst - deshalb hier jeweils
      // das NAECHSTE Bild anstossen, damit es beim Ueberblenden schon da ist.
      const preload = (i) => { slides[i % slides.length].loading = 'eager'; };
      let current = 0;
      preload(1);
      const next = () => {
        slides[current].classList.remove('is-active');
        current = (current + 1) % slides.length;
        slides[current].classList.add('is-active');
        preload(current + 1);
      };
      window.setTimeout(() => {
        next();
        window.setInterval(next, interval);
      }, firstDelay);
    }
  }

  // ── Startseite: Day/Night-Slider ──────────────────────────────────────────
  // 25.09.2026. Knopf per Maus/Finger zu einer Seite ziehen; ab 55 % des Wegs
  // gilt die Seite als gewaehlt, sonst federt der Knopf in die Mitte zurueck.
  // Alternativ: Pfeiltasten auf dem Knopf oder Tippen auf "Day"/"Night".
  // Gewaehlt -> der Knopf faehrt ans Ende, die Wipe-Flaeche (Farbe der
  // Zielseite) schiebt sich von dieser Seite ueber den Bildschirm, danach
  // wird die Seite geladen.
  const edSwitch = document.querySelector('[data-violex-switch]');
  if (edSwitch) {
    const track = edSwitch.querySelector('[data-violex-switch-track]');
    const knob = edSwitch.querySelector('[data-violex-switch-knob]');
    const rail = edSwitch.querySelector('[data-violex-switch-rail]') || track;
    const links = {
      day: edSwitch.querySelector('[data-violex-switch-side="day"]'),
      night: edSwitch.querySelector('[data-violex-switch-side="night"]'),
    };
    const wipe = document.querySelector('[data-violex-wipe]');
    const wipeText = document.querySelector('[data-violex-wipe-text]');
    const reduceMotionSwitch = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    let leaving = false;

    // Maximaler Weg des Knopfs von der Mitte bis ans Ende der Linie
    // (die Linie liegt zwischen "Day" und "Night").
    const maxX = () => rail.clientWidth / 2 - knob.offsetWidth / 2;

    const setX = (x) => {
      const max = maxX();
      const clamped = Math.max(-max, Math.min(max, x));
      track.style.setProperty('--switch-x', `${clamped}px`);
      track.style.setProperty('--switch-pull', (clamped / max).toFixed(3));
      return clamped / max;
    };

    const go = (side) => {
      if (leaving) return;
      leaving = true;
      track.classList.remove('is-dragging', 'is-nudging');
      setX(side === 'day' ? -maxX() : maxX());
      knob.setAttribute('aria-valuenow', side === 'day' ? '-1' : '1');
      knob.setAttribute('aria-valuetext', side === 'day' ? 'Day' : 'Night');

      const href = links[side].href;
      if (!wipe || reduceMotionSwitch) {
        window.location.href = href;
        return;
      }
      wipeText.textContent = side === 'day' ? 'Day Edition' : 'Night Edition';
      wipe.classList.remove('is-day', 'is-night', 'is-active');
      wipe.classList.add(side === 'day' ? 'is-day' : 'is-night');
      void wipe.offsetWidth; // Startposition festschreiben, sonst keine Transition
      wipe.classList.add('is-active');
      window.setTimeout(() => { window.location.href = href; }, 750);
    };

    const reset = () => {
      leaving = false;
      track.classList.remove('is-dragging');
      setX(0);
      knob.setAttribute('aria-valuenow', '0');
      knob.setAttribute('aria-valuetext', 'Center');
      if (wipe) wipe.classList.remove('is-active', 'is-day', 'is-night');
    };

    // Ziehen (Pointer Events decken Maus, Finger und Stift ab).
    let startX = 0;
    let dragging = false;
    let pull = 0;
    knob.addEventListener('pointerdown', (e) => {
      if (leaving) return;
      dragging = true;
      startX = e.clientX;
      pull = 0;
      track.classList.remove('is-nudging');
      track.classList.add('is-dragging');
      knob.setPointerCapture(e.pointerId);
    });
    knob.addEventListener('pointermove', (e) => {
      if (!dragging) return;
      pull = setX(e.clientX - startX);
    });
    const endDrag = () => {
      if (!dragging) return;
      dragging = false;
      track.classList.remove('is-dragging');
      if (pull <= -0.55) go('day');
      else if (pull >= 0.55) go('night');
      else setX(0);
    };
    knob.addEventListener('pointerup', endDrag);
    knob.addEventListener('pointercancel', endDrag);

    // Tastatur: Pfeil links = Day, Pfeil rechts = Night.
    knob.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowLeft') { e.preventDefault(); go('day'); }
      if (e.key === 'ArrowRight') { e.preventDefault(); go('night'); }
    });

    // Tippen auf das Wort: gleicher Uebergang statt harter Seitenwechsel.
    Object.entries(links).forEach(([side, link]) => {
      link.addEventListener('click', (e) => {
        if (e.metaKey || e.ctrlKey || e.shiftKey || e.button !== 0) return;
        e.preventDefault();
        go(side);
      });
    });

    // Zurueck-Taste (bfcache): Seite kommt im Endzustand zurueck -> zuruecksetzen.
    window.addEventListener('pageshow', (e) => { if (e.persisted) reset(); });

    // Einmaliger Hinweis-Schubser kurz nach dem Laden.
    if (!reduceMotionSwitch) {
      window.setTimeout(() => {
        if (!dragging && !leaving) track.classList.add('is-nudging');
      }, 1200);
      track.addEventListener('animationend', () => track.classList.remove('is-nudging'));
    }
  }

  // ── Cart count badge ───────────────────────────────────────────────────────
  function updateCartBadge(count) {
    const badge = document.getElementById('vx-nav-cart-count');
    if (!badge) return;
    badge.textContent = count;
    badge.style.display = count > 0 ? '' : 'none';
    const cartLink = document.querySelector('.violex-nav__cart');
    if (cartLink) {
      cartLink.setAttribute('aria-label', `Cart (${count} items)`);
    }
  }

  async function refreshCartCount() {
    try {
      const res  = await fetch('/cart.js');
      const data = await res.json();
      updateCartBadge(data.item_count);
    } catch { /* ignore */ }
  }

  document.addEventListener('violex:cart:add',     refreshCartCount);
  document.addEventListener('violex:cart:updated', (e) => {
    if (e.detail?.count !== undefined) {
      updateCartBadge(e.detail.count);
    } else {
      refreshCartCount();
    }
  });

});
